export class JoinRequest {
  id = "";
  password = "";
  name = "";
  birth = "";
  email = "";
  gender = 0;

  init(
    id: string,
    password: string,
    name: string,
    birth: string,
    email: string,
    gender: number
  ) {
    this.id = id;
    this.password = password;
    this.name = name;
    this.birth = birth;
    this.email = email;
    this.gender = gender;
  }
}

export class LoginRequest {
  id = "";
  password = "";
  autoLogin = false;
  nextUrl = "";

  constructor(id: string, password: string, autoLogin: boolean) {
    this.id = id;
    this.password = password;
    this.autoLogin = autoLogin;
  }

  public getFormData() {
    const formData = new FormData();
    formData.append("id", this.id);
    formData.append("password", this.password);
    formData.append("autoLogin", this.autoLogin ? "true" : "false");
    return formData;
  }
}

export class UserInfo {
  userId = 0;
  id = "";
  name = "";
  nickname = "";
  role = "";

  //   constructor(userId: number, id: string, name: string, nickname: string) {
  //     this.userId = userId;
  //     this.id = id;
  //     this.name = name;
  //     this.nickname = nickname;
  //   }

  public setUserInfo(
    userId: number,
    id: string,
    name: string,
    nickname: string,
    role = ""
  ) {
    this.userId = userId;
    this.id = id;
    this.name = name;
    this.nickname = nickname;
    this.role = role;
  }

  public setUserInfoByResponse(res: any) {
    this.userId = res.data.userId;
    this.id = res.data.id;
    this.name = res.data.name;
    this.nickname = res.data.nickname;
    this.role = res.data.role ?? "";
  }

  public isLogin() {
    return this.userId > 0;
  }

  public isAdmin() {
    return this.role === "ROLE_ADMIN";
  }
}

export class UserDetailInfo {
  id = "";
  name = "";
  nickname = "";
  birth = "";
  email = "";
  gender = 0;

  public bind(res: any) {
    this.id = res.data.id;
    this.name = res.data.name;
    this.nickname = res.data.nickname;
    this.birth = res.data.birth;
    this.email = res.data.email;
    this.gender = res.data.gender;
  }

  public setUserDetail(
    id: string,
    name: string,
    nickname: string,
    birth: string,
    email: string,
    gender: number
  ) {
    this.id = id;
    this.name = name;
    this.nickname = nickname;
    this.birth = birth;
    this.email = email;
    this.gender = gender;
  }
}

export class UserUpdateRequest {
  //
  password = "";
  nickname = "";
  name = "";
  birth = "";
  email = "";
  gender = 0;
  // phone = "";
  memo = "";

  public setRequest(
    password: string,
    nickname: string,
    name: string,
    birth: string,
    email: string,
    gender: number,
    // phone: string,
    memo: string
  ) {
    this.password = password;
    this.nickname = nickname;
    this.name = name;
    this.birth = birth;
    this.email = email;
    this.gender = gender;
    // this.phone = phone;
    this.memo = memo;
  }
}

export class UserFindIdRequest {
  name = "";
  birth = "";
  email = "";

  public setRequest(name: string, birth: string, email: string) {
    //
    this.name = name;
    this.birth = birth.replace(/-/g, "");
    this.email = email;
  }
}

export class UserResetPasswordRequest {
  id = "";
  name = "";
  birth = "";
  email = "";
  password = "";

  public setRequest(
    id: string,
    name: string,
    birth: string,
    email: string,
    password: string
  ) {
    //
    this.id = id;
    this.name = name;
    this.birth = birth.replace(/-/g, "");
    this.email = email;
    this.password = password;
  }
}
